<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        type="pagetop"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        setHeight="500px"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            dense
            :is="tab.component"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
export default {
  name: 'local-exhaust-system-plan-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      tab: 'localExhaustSystemPlanDoc',
      tabItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.tabItems = [
        // 기본정보
        // { name: 'localExhaustSystemPlanInfo', icon: 'info', label: '환기장치(국소배기장치) 설치계획', component: () => import(`${'./localExhaustSystemPlanInfo.vue'}`) },
        // 도면
        // { name: 'localExhaustSystemPlanPid', icon: 'tab', label: '환기장치(국소배기장치) 설치계획도', component: () => import(`${'./localExhaustSystemPlanPid.vue'}`) },
        // 문서
        { name: 'localExhaustSystemPlanDoc', icon: 'assignment', label: '유해위험방지계획서', component: () => import(`${'./localExhaustSystemPlanDoc.vue'}`) }
      ]
    },

  }
};
</script>